module.exports = __webpack_public_path__ + "static/media/safeZone.b8f8da67.svg";